"use strict"

import React from "react"
import { injectIntl } from "react-intl"

import { Modal, Button } from "react-bootstrap"

function AreYouSureModal({
  size = "xl",
  show,
  onHide,
  warning,
  submitForm,
  cancelForm,
  data,
  modalBody,
  deleteMode,
  intl,
}) {
  return (
    <Modal
      size={size}
      dialogClassName={"common-modal"}
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
      backdrop={"static"}
    >
      <>
        <Modal.Header closeButton>
          <Modal.Title className={"text-center"}>
            {deleteMode && `${intl.formatMessage({ id: "general.delete" })}: `}
            {intl.formatMessage({ id: "areyousuremodal.header" })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {warning && (
            <h5 style={{ margin: "10px" }} className={"error-message"}>
              {intl.formatMessage({ id: "general.server.error" })}
            </h5>
          )}
          {modalBody}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={"outline-primary"}
            style={{ marginRight: "auto" }}
            type={"reset"}
            onClick={(e) => cancelForm(e)}
          >
            {intl.formatMessage({ id: "general.cancelButton" })}
          </Button>
          <Button
            style={{ marginLeft: "auto" }}
            variant={deleteMode ? "danger" : "primary"}
            type={deleteMode ? "delete" : "submit"}
            onClick={(e) => submitForm(e, data)}
          >
            {intl.formatMessage({ id: deleteMode ? "general.delete" : "general.submitButton" })}
          </Button>
        </Modal.Footer>
      </>
    </Modal>
  )
}

export default injectIntl(AreYouSureModal)
